import { useEffect, useState } from 'react';
import {
	// eslint-disable-next-line camelcase
	entitlementsDetails_get_byEntitlementId_v1,
	type EntitlementDetails,
} from '@atlassian/commerce-ccp-gateway-client';
import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';

type UseEntitlementInformationProps = {
	entitlementId: string | null;
};

export const useEntitlementInformation = ({ entitlementId }: UseEntitlementInformationProps) => {
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);
	const [data, setData] = useState<EntitlementDetails | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);

			try {
				const entitlementResponse = getSuccessfulResultOrThrow(
					await entitlementsDetails_get_byEntitlementId_v1({
						pathParameters: { entitlementId: entitlementId || '' },
					}),
				);

				setData(entitlementResponse);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				setError(err);
			}
			setLoading(false);
		};

		if (entitlementId && entitlementId.trim().length > 0) {
			fetchData();
		} else {
			setLoading(false);
		}
	}, [entitlementId]);

	return {
		loading,
		error,
		data,
	};
};
